module.exports = __webpack_public_path__ + "img/mobilecard.908f8b8b.svg";